import React, { Component } from 'react';
import Masonry from 'react-masonry-component';
import MasonryItemCaption from './MasonryItemCaption';

class MasonryDesk extends Component {
  
  render() {
    const masonryOptions = {
      transitionDuration: 0
    };
    return (
      <Masonry
        ref={function(c) {this.masonry = this.masonry || c.masonry;}.bind(this)}
        className={'masonry-grid-wrapper masonry-grid-desktop loaded'}
        elementType={'ul'}
        options={masonryOptions}
        disableImagesLoaded={false}
        updateOnEachImageLoad={true}
      >
        {this.props.GridItems.map((item, i) =>
          <MasonryItemCaption itemData={item} isMobile={false} key={'masonry-item-desk' + item.image.id + i}/>
        )}
      </Masonry>
    );
  }
};

export default MasonryDesk;



// WEBPACK FOOTER //
// ./src/components/filter-pages/MasonryDesk.js